export default __webpack_public_path__ + "static/media/mobile4.4d56a68b.jfif";